<ng-container *transloco="let t">
  <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="slash-command-scroll">
    <div class="p-0 mb-0">
      @for (item of props.items; track item.id; let i = $index) {
      <div
        [ngClass]="{ active: i === selectedIndex }"
        (click)="selectItem(i)"
        data-id="{{ item.id }}"
      >
        <div class="content-builder-menu-list">
          <div class="content-builder-menu-list-icon {{ item.type }}"></div>
          <div class="content-builder-menu-list-label">
            <p>{{ item.title }}</p>
            <p>
              {{t("Slash command text (Template/Document - section) - Insert a new")}}
              <span>{{ item.title | lowercase }}</span>
            </p>
          </div>
        </div>
      </div>
      }
    </div>
  </ng-scrollbar>
</ng-container>
